import BaseAPI from "./BaseAPI";

class FileAPI extends BaseAPI {
	
    getFiles2 = () => {
        var promise = this.init().get("/account/files");
        return promise;
    };
	
	getFiles = async () => {
		var promise = await this.init().get("/account/files");
		return promise;
	};

    getFilesForMap = async (mapId) => {
        var promise = await this.init().get("/account/files/"+mapId);
        return promise;
    };

    downloadFile2 = async (data) => {
        var promise = await this.init().get("/account/files/downloadFile/"+data.tenantKey.trim()+"/"+data.file.id);
        return promise;
    };


	downloadFile = async () => {
		var promise = await this.init().get("/account/downloadFile");
		return promise;
	};

	deleteFile = async (data) => {
        var promise = await this.init().delete("/account/files/deleteFile/"+data.tenantKey.trim()+"/"+data.file.id);
		return promise;
	};

    addFileDescription = async (fileId, description) => {
        var promise = await this.init().post("/account/file/"+fileId, {description:description});
        return promise;
    };

	storeFile = async (data, mapId) => {
		let formData = new FormData();
		formData.append("file", data);
		formData.append("test", "dit is een test");
		formData.append("mapkey", JSON.stringify(mapId) );
		var promise = await this.init().post("/account/files", formData,  {
				headers: {
					"Content-Type": "multipart/form-data; charset=UTF-8",
			}});
		return promise;
	};

    storeDocument = async (data) => {
        let formData = new FormData();
        formData.append("document", JSON.stringify(data) );
        formData.append("file", data?.file);
        formData.append("test", "dit is een test");
        var promise = await this.init().post("/account/document", formData,  {
                headers: {
                    "Content-Type": "multipart/form-data; charset=UTF-8",
            }});
        return promise;
    };

    getUserDocuments = async (data = null) => {
        let link = "/account/documents";
        if(data && data?.key) {
            link += "/"+data.key;
        }
        var promise = await this.init().get(link);
        return promise;
    };
	
    deleteDocument = async (document) => {
        let link = "/account/document/"+document.key;
        if(document.team) {
            link = "/account/document/"+document.user_key+"/"+document.key;
        }
        var promise = await this.init().delete(link);
        return promise;
    };
	
}

export default new FileAPI();